/**
 * 403 Forbidden Page
 * 
 * Displayed when user lacks required permissions.
 */

import { Link } from 'react-router-dom';
import { ROUTES } from '@threadlock/routing';

export default function ForbiddenPage() {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col items-center justify-center min-h-[60vh]">
        <h1 className="text-6xl font-bold text-neutral-900 mb-4">403</h1>
        <h2 className="text-2xl font-semibold text-neutral-700 mb-4">Access Denied</h2>
        <p className="text-neutral-600 mb-8 text-center max-w-md">
          You don't have permission to access this page.
          Please contact your workspace administrator if you believe this is an error.
        </p>
        <Link
          to={ROUTES.DASHBOARD}
          className="px-6 py-3 bg-neutral-900 text-white rounded-lg hover:bg-neutral-800 transition-colors"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
